import {
  Button,
  Card,
  Checkbox,
  Collapse,
  Flex,
  type FormInstance,
} from "antd";
import ViewIcon from "../../../../../assets/icons/ViewIcon";
import EditIcon from "../../../../../assets/icons/EditIcon";
import ChevronDownIcon from "../../../../../assets/icons/ChevronDownIcon";
import TvIcon from "../../../../../assets/icons/TvIcon";
import Image from "../../../../../assets/images/Rectangle.png";
import { useState } from "react";
import Overview from "./Overview";

type Props = { form: FormInstance<any> };

const tabs = ["Overview", "Notes", "Announcements", "Reviews"];

export default function PreviewCourse({ form }: Props) {
  const [activeTab, setActiveTab] = useState("Overview");

  console.log(form);

  return (
    <>
      <div>
        <Flex align="center" justify="space-between" gap={16}>
          <Button
            type="default"
            size="middle"
            className="btn-bordered-primary border-none shadow-none !bg-transparent
              hover:!border-zinc-200 focus:!border-zinc-200 active:!border-zinc-200 mt-3"
          >
            <ViewIcon className="text-[#455468] text-base" /> Viewing as a
            Learner
          </Button>

          <Button
            type="default"
            size="middle"
            className="btn-bordered-primary border border-zinc-200
              hover:!border-zinc-200 focus:!border-zinc-200 active:!border-zinc-200 mt-3"
          >
            <EditIcon className="text-[#455468] text-base" /> Viewing as a
            Learner
          </Button>
        </Flex>

        <div className="grid grid-cols-12 gap-4 mt-3">
          {/* Left Section */}
          <div className="col-span-12 md:col-span-8">
            <Card
              className="rounded-md shadow-sm w-full"
              bodyStyle={{ padding: "22px" }}
            >
              <div className="h-full bg-neutral-200 rounded-lg">
                <img src={Image} alt="course_image"></img>
              </div>

              <div className="w-full mt-5">
                {/* SEGMENT HEADER */}
                <div className="flex gap-6 border-b border-[#D7DFE9]">
                  {tabs.map((tab) => {
                    const isActive = activeTab === tab;

                    return (
                      <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        className={`
                pb-1 text-sm font-medium transition-all
                ${
                  isActive
                    ? "text-[#EC7323] border-b-2 border-[#EC7323]"
                    : "text-[#5E718D] border-b-2 border-transparent hover:text-[#EC7323]"
                }
              `}
                      >
                        {tab}
                      </button>
                    );
                  })}
                </div>

                {/* SEGMENT CONTENT */}
                <div className="mt-6">
                  {activeTab === "Overview" && <Overview />}
                  {activeTab === "Notes" && <div>Notes</div>}
                  {activeTab === "Announcements" && <div>Announcements</div>}
                  {activeTab === "Reviews" && <div>Reviews</div>}
                </div>
              </div>
            </Card>
          </div>

          {/* Right Section */}
          <div className="col-span-12 md:col-span-4">
            <Card
              className="rounded-md shadow-sm w-full"
              bodyStyle={{ padding: "0px" }}
            >
              <div className="px-4 py-3 border-b font-bold text-zinc-700 text-base">
                Course Content
              </div>

              <Collapse
                bordered={false}
                className="bg-white"
                expandIconPosition="end"
                expandIcon={({ isActive }) => (
                  <ChevronDownIcon
                    className={`w-5 h-5 text-gray-500 transition-transform ${
                      isActive ? "rotate-180" : ""
                    }`}
                  />
                )}
                items={courseSections.map((section, index) => ({
                  key: index.toString(),
                  label: (
                    <div className="flex flex-col">
                      <span className="font-medium text-slate-700 text-base">
                        {section.title}
                      </span>

                      <span className="text-xs text-slate-600 font-normal">
                        {section.progress}
                      </span>
                    </div>
                  ),
                  children: (
                    <div className="space-y-3">
                      {section.lectures.map((lecture, i) => (
                        <div key={i} className="flex items-start gap-3 text-sm">
                          {/* Checkbox */}
                          <Checkbox className="mt-1" />

                          {/* Content */}
                          <div className="flex flex-col">
                            {/* Title (First Line) */}
                            <span className="text-slate-600 text-sm font-normal">
                              {lecture.title}
                            </span>

                            {/* Meta (Second Line) */}
                            <div className="flex items-center gap-1 mt-1">
                              <TvIcon className="w-4 h-4 text-[#5E718D]" />
                              <span className="text-slate-500 text-xs font-normal">
                                {lecture.duration}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ),
                }))}
              />
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}

const courseSections = [
  {
    title: "Section 1: Introduction",
    progress: "0/11 | 42min",
    lectures: [
      { title: "Welcome Message", duration: "2 mins" },
      { title: "Meet Your Instructor", duration: "5 mins" },
      { title: "Syllabus Overview", duration: "6 mins" },
      { title: "Learning Objectives", duration: "3 mins" },
      { title: "Community Guidelines", duration: "4 mins" },
      { title: "Getting Started", duration: "8 mins" },
    ],
  },
  {
    title: "Section 1: Introduction",
    progress: "11/11 | 42min",
    lectures: [],
  },
  {
    title: "Section 1: Introduction",
    progress: "11/11 | 42min",
    lectures: [],
  },
];
